module.exports = __webpack_public_path__ + "img/healz.460ec42f.png";